export function isFavoriteParticipantsFilterTabActive(filterParams) {
    return filterParams?.favorites;
}
